import { useCallback } from 'react';
import { fundAccount } from '../../../../wallet/utilities/api';
import { useDispatch } from 'react-redux';
import { getAccountInformation } from '../../../../store/account-information/account-information.actions';

export const useWalletAddFunds = (walletId) => {
  const dispatch = useDispatch();
  return useCallback(
    (amount) => {
      return fundAccount(walletId, amount).finally(() => {
        dispatch(getAccountInformation());
      });
    },
    [walletId, dispatch],
  );
};
